var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLazyLoaded)?_c('pedia-assistant',{ref:"pediaAssistant",staticClass:"pedia-assistant",attrs:{"api-base-url":_vm.$env.API_URL},on:{"hook:mounted":_vm.loadedPromiseResolve,"show-results":_vm.onShowResults}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }